export default __webpack_public_path__ + "img/link_hover.b9eec633107d349ce4d3539bd18f5c94.svg";